// extracted by mini-css-extract-plugin
export default {"secondary-nav-border":"1px solid rgba(255, 255, 255, 0.24)","partner":"styles_partner__H1M4N","container":"styles_container__MfX3v"};